module.exports = __webpack_public_path__ + "img/FILM[GYRI]-icon.da9f20c.png";